import { render, staticRenderFns } from "./description.vue?vue&type=template&id=f47cdcd6&scoped=true"
import script from "./description.vue?vue&type=script&lang=js"
export * from "./description.vue?vue&type=script&lang=js"
import style0 from "./description.vue?vue&type=style&index=0&id=f47cdcd6&prod&lang=scss&scoped=true"
import style1 from "./description.vue?vue&type=style&index=1&id=f47cdcd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47cdcd6",
  null
  
)

export default component.exports